
import http from './http';
import { BrandReactivationResponse, BrandReactivationRequest } from '@monolith/legacy/types/api/brand';

export const getBrandReactivationStatus = async (): Promise<BrandReactivationResponse> => {
    const response = await http()
    .get(`/api/internal/v1/brands/reactivations/-actions/status`)
    .then((response) => response.data);

    return response;
}


export const updateBrandReactivationStatus = async (request: BrandReactivationRequest): Promise<BrandReactivationResponse> => {
    const response = await http()
    .post(
        `/api/internal/v1/brands/reactivations/-actions/transition`,
        {
            data: {
                type: request
            }
        }
    )
    .then((response) => response.data);

     return response;
}
